import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { HelpCircle } from "react-feather";

import WheelImg from "~/assets/images/dailyGoals/wheel-of-fortune.png";

import OverlayModal from "~/components/overlayModal";

import GamesPaginator   from "./Paginator/Games"
import GameModal        from "./Modals/GameModal";
import LimitedGameModal from "./Modals/LimitedGameModal";
import TokensWheelModal from "./Modals/TokensWheelModal";
import InfoModal        from "./Modals/InfoModal";

import User from "~/services/user";


const Games = ()=> {

  const [userPoints       , setUserPoints       ] = useState(0);
  const [acceptedCashouts , setAcceptedCashouts ] = useState(0);
  const [availableTokens  , setAvailableTokens  ] = useState(0);
  const [accCreatedDays   , setAccCreatedDays   ] = useState(0);
  const [selectedGame     , setSelectedGame     ] = useState({});
  const [selectedModal    , setSelectedModal    ] = useState(false);
  const [overlayOpen      , setOverlayOpen      ] = useState(false);
  const [user             , setUser             ] = useState();
  const [refreshPage      , setRefreshPage      ] = useState(false);

  const msInDay = 1000*60*60*24;
  const limits = {acceptedCashouts, availableTokens, userPoints, accCreatedDays};

  useEffect(()=> {
    (async()=> {
      let user = await User.account();
      setUser(user);
      setUserPoints(user.totalPoints);
      setAcceptedCashouts(user.acceptedCashouts);
      setAvailableTokens(user.activityTokens);
      setAccCreatedDays(Math.floor( (new Date().getTime() - new Date(user.createdAt).getTime()) / msInDay ));
    })();
  }, [refreshPage]);

  const checkLimitedGame = (game) => {
    setSelectedGame(game);
    setSelectedModal("limited");
  };

  const refresh = ()=> {
    if(!refreshPage)
      setRefreshPage(true);
  };

  const openWheel = ()=> {
    setSelectedModal("tokens");
  };

  return (
    <div className="games-page">
      <div className={"games-title"}>
        <h1> Games </h1>
        <img src={WheelImg} className={"gift"} onClick={openWheel}></img>
      </div>

      <InfoModal
        isModalOpen={selectedModal === "info"}
        setModalOpen={setSelectedModal}
      />

      <LimitedGameModal
        isModalOpen={selectedModal === "limited"}
        setModalOpen={setSelectedModal}
        item={selectedGame}
        limits={limits}
      />

      <TokensWheelModal
        isModalOpen={selectedModal === "tokens"}
        setIsModalOpen={setSelectedModal}
        refresh={refresh}
      />

      <Container fluid={true}>
        <div className="info-msg" onClick={()=> setSelectedModal("info") }>

          <div className="info-text"> <HelpCircle/>  How to win new tokens? </div>

          <div className="d-flex jc-center">
            {!user
              ? <div className="tokens-placeholder"></div>
              : <div className="tokens-wrapper">
                <p>Available Tokens: </p>
                <div className="tokens">{availableTokens}</div>
              </div>
            }
          </div>
        </div>

        <GamesPaginator setOverlayOpen={setOverlayOpen} setSelectedGame={setSelectedGame} limits={limits} checkLimitedGame={checkLimitedGame} />
      </Container>

      <OverlayModal title="Reach the target and get instant points!" opened={overlayOpen} onClose={()=> setOverlayOpen(false)}>
        <GameModal selectedGame={selectedGame} />
      </OverlayModal>

    </div>
  );
};

export default Games;
